import styled from 'styled-components';

export const MainContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.75rem 2.75rem 0.75rem 0.75rem; /* Space for optional icon on the right */
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;

  &:disabled {
    background-color: #f5f5f5;
  }
`;

export const RightElementContainer = styled.div`
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  color: #666;

  & > * {
    margin-left: 0.25rem;
    cursor: pointer;

    &:hover {
      color: #000;
    }
  }
`;